import React from "react";
import { Card, CardContent, Grid, Typography } from "@mui/material";

function Applications({ numberOfInterviews, title, image }) {
    return (
      <Card sx={{ display: "flex", alignItems: "center", padding: 1, backgroundColor: "#fff", width: "100%", borderRadius: "8px", marginBottom: 2 }}>
        {/* Image on the Left */}
        <img
          src={image}
          alt="Interview"
          style={{
            width: 60,
            height: 60,
            marginRight: 20
          }}
        />
  
        {/* Content (Text and Number of Interviews) */}
        <CardContent sx={{}}>
          <Typography variant="h5" sx={{ fontWeight: "bold",color:"#000",fontSize:"16px" }}>
            {title}
          </Typography>
          <Typography variant="h5" sx={{ fontWeight: "bold", color: "#000",fontSize:"16px" }}>
            {numberOfInterviews}
          </Typography>
        </CardContent>
      </Card>
    );
  }
  
export default Applications;
